var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-signin-to-code"},[_c('Spin',{attrs:{"spinning":_vm.spinning,"tip":_vm.tip}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }